/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * smoothScrollTrigger.js
 */

/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * スムーススクロール
 */
const smoothScrollTo = () => {
  let anchorLinks = document.querySelectorAll('a[href^="#"]');
  const anchorLinksArr = Array.prototype.slice.call(anchorLinks);
  const headerHeight = document.querySelector('header').offsetHeight;

  anchorLinksArr.forEach((link) => {
    link.addEventListener("click", (e) => {
      e.preventDefault();
      const href = e.currentTarget.getAttribute("href");
      const targetId = href.substring(href.indexOf("#"));
      const targetOffsetTop = !targetId ? 0 : window.pageYOffset + document.querySelector(targetId).getBoundingClientRect().top - headerHeight;
      window.scrollTo({
        top: targetOffsetTop,
        behavior: "smooth",
      });
    });
  });

  // ページ内リンクでページ遷移した後にスクロール位置を調整
  window.addEventListener("load", () => {
    let e = location.href;
    if (e.indexOf("#") != -1) {
      let targetId = e.substring(e.indexOf("#"));
      let targetOffsetTop = window.pageYOffset + document.querySelector(targetId).getBoundingClientRect().top - headerHeight;
      window.scrollTo({
        top: targetOffsetTop,
        behavior: "smooth",
      });
    }
  });
};

export {
  smoothScrollTo
};